// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsGoalsTemplate_heading__patCL"};